<template>
  <div>
    <b-card-text>
      キャラクターの能力値を一時的に増減します。
    </b-card-text>
    <b-form-group id="status" label="ステータス">
      <b-form-input v-model="innerValue.arguments.status" />
    </b-form-group>
    <b-form-group id="num" label="値">
      <b-form-input v-model="innerValue.arguments.value" 
        type="number" min="-99" max="99" number />
    </b-form-group>
    <b-button variant="danger" size="sm"
      @click="$emit('removeCode')">
      <b-icon icon="x" />削除
    </b-button>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    value: Object
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  mounted () {
    if(!this.innerValue.arguments.player){
      _.assign(this.innerValue.arguments, {
        player: { '@register':'player' },
      })
    }
  },
  watch: {
    'innerValue.arguments' () {
      this.$emit('input', this.innerValue)
    },
    value (v) {
      this.innerValue = v
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
